/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import * as React from 'react';
import Container from './Container';
import { IHeadProps } from '../TableHead';

interface IComponentProps {
  label: boolean;
  action?: (title: string, e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

type Props = IHeadProps & IComponentProps;

const AllTypes: React.FC<Props> = ({ ...props }) => {
  return (
    <Container
      openedMenuName={props.openedMenuName}
      activePaging={props.activePaging}
      activeRows={props.activeRows}
      activeSorting={props.activeSorting}
      action={props.action}
      label={props.label}
      columns={props.columns}
      stateValue={props.stateValue}
      parentState={props.parentState}
      filterComponent={props.filterComponent}
      actionOpen={props.actionOpen}
      setValue={props.setValue}
      actionSave={props.actionSave}
      reset={props.reset}
      name={props.name}
      tableName={props.tableName}
    />
  );
};

export default AllTypes;
